
import { Component, Vue } from "vue-property-decorator";
import Tabs from "@/components/Tabs/Tabs.vue";
import { TTab } from "@/models/tabs";
import { employerCompanyLinks } from "./REmployerCompany";
import { SMUser } from "@/store";

const COMPANY_PATH = "company";
const DOCUMENTS_PATH = "documents";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Tabs,
    ComplianceExpiredWidget: () => import("@/modules/Compliance/ComplianceExpiredWidget.vue"),
  },
})
export default class Company extends Vue {
  get widgetExpiredDescription() {
    return this.$tc("widgetExpired.description");
  }

  get isDocumentsPage() {
    return this.$route.path.includes(DOCUMENTS_PATH);
  }

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  get showToolbar() {
    return this.getRouteMatches(COMPANY_PATH) || this.isDocumentsPage;
  }

  get tabs(): TTab[] {
    return employerCompanyLinks.map(({ path, label }) => ({
      path: `${SMUser.basePath}${path}`,
      label: label.toUpperCase(),
      isActive: this.$route.path.includes(path),
    }));
  }

  getRouteMatches(name: string) {
    const parts = this.$route.path.substring(1).split("/");

    return parts.some((part) => part === name);
  }
}
